<span>{{data.message}}</span><div class="mat-simple-snackbar-action" *ngIf="hasAction"><button mat-button (click)="action()">{{data.action}}</button></div>